"use strict";

angular.module("meanApp").config(function($stateProvider) {
  $stateProvider.state("property-portfolio", {
    url: "/property-portfolio/:clientId",
    params: {
      clientId: {
        value: null,
        squash: false
      }
    },
    templateUrl: "app/propertyPortfolio/property-portfolio.html",
    controller: "property-portfolio-controller",
    authenticate: ["user","admin"]
  });
});
